import React, { PureComponent } from 'react';
import { routes } from 'routes';

import './EmptyBasket.scss';

import { goToExternalUrl, scrollHelper, userHelper } from 'helpers';

import { SofaButton } from '@sofology/sofologycomponents';

export class EmptyBasket extends PureComponent {
    componentDidMount() {
        scrollHelper.scrollToTopPage();
    }

    handleClickContinueShopping = () => {
        goToExternalUrl(routes.external.siteHome.path);
    };

    handleClickRetrieveBasket = () => {
        goToExternalUrl(routes.external.login.path);
    };

    render(): JSX.Element {
        return (
            <div className='empty-basket'>
                <div className='empty-basket__title'>
                    It looks like you have no items in your basket.
                </div>
                <div className='empty-basket__content'>
                    {this.shouldShowRetrieveBasketButton() &&
                        <SofaButton
                            text='Retrieve your basket'
                            variant='secondary'
                            onClick={this.handleClickRetrieveBasket}
                        />
                    }
                    <SofaButton
                        text='Continue shopping'
                        variant='secondary'
                        onClick={this.handleClickContinueShopping}
                    />
                </div>
            </div>
        );
    }

    shouldShowRetrieveBasketButton() {
        return !userHelper.isUserLoggedIn();
    }
}